export { panelHeaderTextForStandard, eldStandardLevelLabel }

function panelHeaderTextForStandard(standard) {
  let setCode = standard.standard_set_code
  switch (setCode) {
    case 'CCSS':
    case 'HCPS':
    case 'NACS-PE':
    case 'AELG':
    case 'IELG':
      return `${standard.standard_short_ref} ${standard.cluster}`
    case 'DLM-EE':
    case 'NCSC-CCC':
    case 'TEKS.PCT':
    case 'SC.CCR':
      return standard.standard_short_ref
    case 'NY-PreK':
    case 'CAS':
    case 'GELDS':
    case 'AELS':
    case 'CAS-EEO':
    case 'NECCRS':
    case 'OKAS':
    case 'NV.PKS':
    case 'OLS.SS':
    case 'OLS.S':
    case 'LA-ELDS':
    case 'RIELDS':
    case 'TN-ELDS':
      return `${standard.standard_short_ref}: ${standard.strand}`
    case 'NC.SS':
    case 'NCS':
    case 'NDSSCS':
    case 'ELDS':
      return `${standard.standard_short_ref} ${standard.strand}`
    case 'LSS.LC':
    case 'CPLF':
    case 'VESOL':
    case 'WIDA.ELD':
    case 'NDELS':
    case 'INELS':
    case 'NYSS':
    case 'ASELD':
    case 'HEGSE':
      return `${standard.standard_short_ref} ${standard.subject}`
    case 'NVACS-H':
      return `${standard.standard_short_ref}: ${standard.subject}`
    case 'TPKG':
    case 'ND.CS':
      return `${standard.standard_short_ref} ${standard.domain}: ${standard.cluster}`
    case 'NCSC.CCC':
    case 'DLM.EE':
      return `${standard.strand_domain} ${standard.standard_short_ref}`
    case 'CA-ELD':
      return `${standard.strand}: ${eldStandardLevelLabel(standard)}`
    case 'CA-PE':
      return `${standard.standard_short_ref} ${(standard.cluster &&
        standard.cluster !== '' &&
        standard.cluster) ||
        standard.umbrella_title}`
    case 'ILS-SEL':
      return `${standard.standard_short_ref} ${standard.ils_standard}`
    case 'ETEKS':
      return `${standard.standard_short_ref} ${standard.cluster_description}`
    case 'TEKS':
    case 'TEKS-2017':
      return `${standard.standard_short_ref}, Grade ${standard.grades_str}`
    case 'CDC-AEM':
      return `${standard.standard_long_ref} ${standard.year}: ${standard.subject}`
    case 'NCSCoS':
      if (standard.math_hs_course_strands) {
        return `${standard.standard_long_ref} ${standard.math_hs_course_strands}`
      } else {
        return `${standard.standard_long_ref} ${standard.strand_domain}`
      }
    case 'HELDS':
      if (standard.equivalent_standard_ref) {
        return `${standard.equivalent_standard_ref} ${standard.domain}`
      } else {
        return `HELDS.${standard.standard_short_ref} ${standard.domain}`
      }
    case 'NYSNGLS':
    case 'OLS':
    case 'OLS-E':
    case 'OLS-T':
      return `${standard.standard_long_ref} ${standard.strand_domain}`
    case 'OELDS':
      return `${standard.standard_long_ref} ${standard.domain}`
    case 'OLS-FL':
      return `${standard.standard_long_ref} ${standard.topic}`
    case 'OLS-PE':
      return `${standard.standard_long_ref} ${standard.benchmark_skill}`
    case 'MLS':
      return standard.subject === 'Mathematics'
        ? `${standard.standard_short_ref} ${standard.domain_description}`
        : `${standard.standard_short_ref} ${standard.domain_description}: ${standard.concept}`
    case 'MS-AAAS':
      return `${standard.standard_short_ref} ${standard.math_hs_course ||
        ''} ${standard.hs_subject || ''} ${standard.strand_domain}`
    case 'NJSLS':
    case 'MN':
    case 'MAS':
      return `${standard.standard_short_ref} ${(!!standard.strand_domain &&
        standard.strand_domain) ||
        ''}`
    case 'AZ':
    case 'LSS':
    case 'GSE':
    case 'GECS':
    case 'MCF':
    case 'MAELG':
    case 'PCS':
    case 'PEC':
    case `SCCCRP`:
    case `SCCCR`:
    case 'TSS':
    case 'KS':
    case 'IAS':
    case 'INCC':
    case 'MCCRS':
    case 'WAAPF':
    case 'NVACS':
    case 'NVACSC':
    case 'KY':
    case 'FL':
    case 'FLB':
    case 'MAFS':
    case 'LAFS':
    case 'MS-CCRS':
    case 'NC.ECS':
    case 'IDCCC':
    case 'NMCCSS':
    case 'NDCS':
    case 'IC':
    case 'WCSE':
    case 'HSA-Alt':
    case 'VTAA':
    case 'OEAF':
    case 'IELDS':
    case 'UTCS':
    case 'AKCS':
    case 'WVCCRS':
    case 'WVAAAS':
    case 'OELALS':
    case 'SDSS':
    case 'WAS':
    case 'WIS':
    case 'MELG':
    case 'NCFELD':
    case 'ISELC':
    case 'WISEL':
    case 'CELDG':
    case 'KELS':
    case 'MS-SEL':
    case 'SECD':
    case 'MELS':
    case 'RICS':
    case 'NJ.SLS':
    case 'NDSCS':
    case 'SC-CCR':
      return `${standard.standard_short_ref} ${standard.strand_domain ? standard.strand_domain : ''}`
    case 'Alternate-K-PREP':
      return `${standard.standard_short_ref} ${standard.subject_domain}`
    case 'PAEC':
      return `${standard.standard_short_ref} ${standard.strand_domain_text}`
    case `VSOL`:
      return `${standard.standard_short_ref} ${standard.strand_description}`
    case `VASOL`:
      return `${standard.standard_short_ref} ${standard.subject}`
    case 'IDCS':
    case 'WCPS':
    case 'AAS':
      return `${standard.standard_short_ref} ${standard.math_hs_subject || ''} ${
        standard.strand_domain
      }`
    case 'ACS':
      return `${standard.standard_short_ref} ${standard.strand_domain || standard.domain || ''}`
    case 'WELDG':
      return `${standard.standard_short_ref} ${standard.strand_domain || ''}`
    case 'ALAAS':
    case 'IELF':
    case 'WASEL':
    case 'MDELS':
    case 'WMELS':
    case 'AZ.SEL':
    case 'LELDS':
    case 'OELKS':
    case 'MN-SEL':
    case 'FELDS':
    case 'NJELS':
    case 'TXELG':
    case 'TEKS.PE':
    case 'AZELPS':
    case 'DCELS':
    case 'TPG':
    case 'ITELG':
    case 'NV.ELG':
    case 'FL.RES':
    case 'ND.CTE':
    case 'INAS':
    case 'NGSS':
    case 'CTELDS':
    case 'ME-ELDS':
    case 'NPKS':
    case 'NDPECS':
    case 'NVESCRS':
    case 'NH-ELS':
    case 'CA-T-SEL':
    case 'PTKLF':
    case 'KSELA':
    case 'USS-ELA':
    case 'GSELA':
    case 'KSECE':
    case 'IDCS.ELAL':
    case 'ECS':
    case 'MD-ELS':
    case 'SC-ELS':
    case 'LSS-S':
    case 'PLSEC':
    case 'MT-ELS':
      return `${standard.standard_short_ref} ${standard.domain}`
    case 'ECIPs':
    case 'RELDS':
    case 'IELS':
      return `${standard.standard_short_ref} ${standard.domain}: ${standard.strand}`
    case 'VELS':
    case 'OH-SEL':
      return `${standard.standard_short_ref} ${standard.level}: ${standard.domain}`
    case 'TEKS.SS':
      return `${standard.standard_short_ref} ${standard.hs_course || ''}`
    case 'TEKS.ELPS':
    case 'NYS.SLS':
    case 'TEKS.SCI':
    case 'TEKS-SS':
    case 'NHES':
    case 'ELP':
      return `${standard.standard_short_ref}`
    case 'TEKS.CTE':
        return `${standard.standard_short_ref} ${standard.course}`
    case 'OH.ELDS':
    case 'GMS':
    case 'NY.CDOS':
    case 'NYPKELS':
    case 'MELDS':
    case 'NDES':
    case 'SOL':
      return `${standard.standard_short_ref}: ${standard.domain}`
    case 'TEKS-SCI':
      return `${standard.hs_course_code ? `${standard.hs_course_code}.` : ''}${standard.standard_short_ref} ${standard.strand}`
    case 'MLR':
      return `${standard.standard_short_ref} ${standard.strand}: ${standard.domain}`
    case 'HICCS':
      return `${standard.standard_short_ref}: ${standard.subject_code}`
    case 'MLS.S':
      return `${standard.cluster}`
    default:
      return standard.standard_long_ref
  }
}

function eldStandardLevelLabel(standard) {
  let profLevelNum = parseInt(standard.standard_num)
  if (profLevelNum < 2) return 'Beginner'
  if (profLevelNum === 2) return 'Intermediate'
  if (profLevelNum > 2) return 'Advanced'
  return ''
}
